import layout from '@/layout'

export default {
  path: '/operation',
  component: layout,
  redirect: '/operation/websiteUser',
  name: 'websiteUser',
  meta: {
    title: '运营设置',
    icon: 'setting-config'
  },
  children: [
    {
      path: '/operation/websiteUser',
      component: () => import('@/views/operation/websiteUser/index.vue'),
      meta: {
        title: '用户收集',
        icon: 'web-page'
      }
    }
  ]
}
